import classes from './footer.module.css';
import LogoMark from './logo';

const PRIVACY =
    'https://docs.google.com/document/d/15plLIrlTlMbqiwlLCWeSOIKKNVhM2r11xYJyXSmhGC8';
const TERMS =
    'https://docs.google.com/document/d/1Rfj4Wr1fdJtcz1z1IbBZXH-4RhBQSWvKehl8034dkpM';

const Footer = () => {
    return (
        <footer className={classes.footer}>
            <div className={classes.inner}>
                <div className={classes.top}>
                    <div className={classes.brandCol}>
                        <p className={classes.wordmark}>
                            <LogoMark size={30} className={classes.mark} />
                            PrepAnywhere
                        </p>
                        <p className={classes.line}>
                            Students learn math by doing math.
                        </p>
                    </div>

                    <nav className={classes.cols} aria-label="Footer">
                        <div className={classes.col}>
                            <p className={classes.colHead}>Products</p>
                            <a href="https://www.prepbox.io" target="_blank" rel="noopener noreferrer">
                                PrepBox <span className={classes.for}>students</span>
                            </a>
                            <a href="https://prepboxpro.com" target="_blank" rel="noopener noreferrer">
                                PrepBoxPro <span className={classes.for}>centres</span>
                            </a>
                            <a
                                href="https://apps.apple.com/ca/app/mathpulse/id6759286329"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                MathPulse <span className={classes.for}>parents</span>
                            </a>
                        </div>

                        <div className={classes.col}>
                            <p className={classes.colHead}>Company</p>
                            <a href="#belief">What we believe</a>
                            <a href="#loop">How it works</a>
                            <a href={PRIVACY} target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </a>
                            <a href={TERMS} target="_blank" rel="noopener noreferrer">
                                Terms of Service
                            </a>
                        </div>

                        <div className={classes.col}>
                            <p className={classes.colHead}>Follow</p>
                            <a
                                href="https://www.instagram.com/prepboxmath/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Instagram
                            </a>
                            <a
                                href="https://www.linkedin.com/company/prepanywhere"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                LinkedIn
                            </a>
                            <a
                                href="https://www.youtube.com/channel/UC6PNazM_bdKl1Cu8OMP0PVA"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                YouTube
                            </a>
                        </div>
                    </nav>
                </div>

                <div className={classes.base}>
                    <p>© {new Date().getFullYear()} PrepAnywhere. All rights reserved.</p>
                    <p className={classes.baseNote}>Built for math that gets written down.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
